module.exports = __webpack_public_path__ + "img/7_53.48616862.png";